import { hasPermissionFor } from '../../providers/permission-mapping';

// Minimal shape the filter needs — appbar's AppBarlink satisfies it. Kept
// generic so callers get their own link type back unchanged.
type PermissionedLink = { allowed?: boolean; permissions?: string };

// IM-2594: when `restrict` is OFF, returns the SAME array reference untouched
// (production behaviour). When ON, keeps links explicitly marked `allowed` or
// whose `permissions` the user holds. Pure + React-free so it can be unit
// tested without dragging the appbar's MUI/scss imports into vitest.
export const selectAllowedLinks = <T extends PermissionedLink>(
  links: T[],
  permissions: string[],
  restrict: boolean,
): T[] =>
  restrict
    ? links.filter((link) => link.allowed || hasPermissionFor(permissions, link.permissions))
    : links;
